import SiderMenu from './SiderMenu'
import GlobalHeader from './GlobalHeader'
import Authorized from './Authorized'

export {
  SiderMenu,
  GlobalHeader,
  Authorized
}


// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/components/index.js